import type { ComponentPropsWithoutRef } from 'react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import type { PaidEntitlementPlan } from '@/api/entitlements';
import { cn } from '@/lib/utils';

type AvailablePlan = {
    id: PaidEntitlementPlan;
    name: string;
};

type FeatureUnavailableChipProps = {
    availablePlan: AvailablePlan;
    label?: string;
    message?: string;
    className?: string;
    side?: ComponentPropsWithoutRef<typeof TooltipContent>['side'];
};

export default function FeatureUnavailableChip({
    availablePlan,
    label = 'Plano+',
    message,
    className,
    side = 'top',
}: FeatureUnavailableChipProps) {
    return (
        <TooltipProvider delayDuration={0}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span
                        tabIndex={0}
                        aria-label={`Disponível no plano ${availablePlan.name}`}
                        className={cn(
                            'inline-flex cursor-help items-center rounded-full border border-brand/15 bg-brand-subtle px-2.5 py-1 text-[0.7rem] font-semibold leading-none text-brand shadow-none outline-none transition-colors hover:bg-brand-subtle/80 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
                            className,
                        )}
                    >
                        {label}
                    </span>
                </TooltipTrigger>
                <TooltipContent side={side} className="max-w-56 text-center leading-5">
                    {message ?? `Disponível no plano ${availablePlan.name}`}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
